import "../../Queue.css";
import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
const base = "Queue_base_ccc3c";
const spinner = "Queue_spinner_ccc3c";
const innerSpinner = "Queue_innerSpinner_ccc3c";
const pulse = "Queue_pulse_ccc3c";
const pulseSpinner = "Queue_pulseSpinner_ccc3c";
const css = {
  base,
  spinner,
  innerSpinner,
  pulse,
  pulseSpinner
};
const Queue = ({ backgroundColor, opacity }) => {
  const spinnerStyle = useMemo(() => {
    return { backgroundColor, opacity };
  }, [backgroundColor, opacity]);
  return /* @__PURE__ */ jsxs("div", { className: css.base, children: [
    /* @__PURE__ */ jsx("div", { className: css.spinner, style: spinnerStyle }),
    /* @__PURE__ */ jsx("div", { className: css.innerSpinner, style: spinnerStyle })
  ] });
};
export {
  Queue as default
};
